// The current character selection inside the on-canvas rich text editor, as GLOBAL offsets
// into the layer's editable text (runs joined, '\n' between lines). Lives in a tiny external
// store — NOT the editor context — so the floating toolbar can read "is a span selected, and
// which chars" and route a style click to restyle just that span, without the editor and the
// toolbar re-rendering each other on every selection move.
//
// `range` is null when no rich editor is focused; collapsed (start === end) when the caret is
// just placed (no span selected → style clicks fall back to whole-layer). Set by the editor on
// selectionchange; cleared on blur.

import { create } from 'zustand'

export interface TextRangeSelection {
  layerId: string
  start: number
  end: number
}

interface TextRangeSelectionStore {
  range: TextRangeSelection | null
  set: (range: TextRangeSelection) => void
  clear: () => void
}

export const useTextRangeSelection = create<TextRangeSelectionStore>(set => ({
  range: null,
  set: range => set({ range }),
  clear: () => set({ range: null }),
}))

/** The active non-empty selection for a given layer, or null. Used by the toolbar to decide
 *  whether a style click targets a span (range) or the whole layer. */
export function activeRangeFor(
  range: TextRangeSelection | null,
  layerId: string
): TextRangeSelection | null {
  if (!range || range.layerId !== layerId || range.end <= range.start) return null
  return range
}
